module.exports = __webpack_public_path__ + "img/product-placeholder-14.b90ee88.png";